// extracted by mini-css-extract-plugin
export var actionText = "_h2-4";
export var container = "_h2-0";
export var leftSection = "_h2-1";
export var rightSection = "_h2-2";
export var settingsButton = "_h2-6";
export var settingsIcon = "_h2-7";
export var shortcut = "_h2-5";
export var shortcutGroup = "_h2-3";